"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentsOfferCredits = PaymentsOfferCredits;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const admin_context_1 = require("@src/components/pages/admin/admin-context");
const FormattedDate_1 = require("@src/components/modules/FormattedDate");
const react_intl_1 = require("react-intl");
const elements_1 = require("@src/components/elements");
const react_styled_1 = require("styled-breakpoints/react-styled");
const styled_breakpoints_1 = require("styled-breakpoints");
const styled_components_1 = __importDefault(require("styled-components"));
const moment_1 = __importDefault(require("moment"));
function PaymentsOfferCredits() {
    const intl = (0, react_intl_1.useIntl)();
    const { companyInfo } = (0, admin_context_1.useAdminContextValue)();
    const companyPaymentsCredits = companyInfo.companyPaymentCredits;
    const isLgOrLowerLayout = (0, react_styled_1.useBreakpoint)((0, styled_breakpoints_1.down)('lg'));
    const paymentsTableScroll = isLgOrLowerLayout ? { x: 1000 } : undefined;
    const companyPaymentsCreditsSortedByCreatedAt = companyPaymentsCredits
        ? [...companyPaymentsCredits].sort((fst, snd) => new Date(fst.createdAt) > new Date(snd.createdAt) ? -1 : 1)
        : [];
    const columns = [
        {
            title: intl.formatMessage({
                id: 'admin.payments.credits.bought',
            }),
            key: 'purchasedCreditAmount',
            dataIndex: 'purchasedCreditAmount',
            align: 'center',
        },
        {
            title: intl.formatMessage({
                id: 'admin.payments.credits.used',
            }),
            key: 'usedCreditAmount',
            dataIndex: 'usedCreditAmount',
            align: 'center',
        },
        {
            title: intl.formatMessage({
                id: 'admin.payments.credits.created_on',
            }),
            key: 'createdAt',
            dataIndex: 'createdAt',
            align: 'center',
            render: (createdAt) => {
                return (0, jsx_runtime_1.jsx)(FormattedDate_1.FormattedDate, { value: createdAt, day: "numeric", month: "numeric", year: "numeric" });
            },
        },
        {
            title: intl.formatMessage({
                id: 'admin.payments.credits.expires_on',
            }),
            key: 'expirationDate',
            dataIndex: 'expirationDate',
            align: 'center',
            render: (expirationDate, record) => {
                // Only show expiration info if there are unused credits
                if (record.purchasedCreditAmount !== record.usedCreditAmount) {
                    const isExpired = (0, moment_1.default)().isAfter(expirationDate);
                    if (isExpired) {
                        return (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.credits.expired" });
                    }
                    else {
                        const count = Math.ceil((0, moment_1.default)(expirationDate).diff((0, moment_1.default)(), 'days', true));
                        return intl.formatMessage({ id: 'general.day.pluralized' }, { count });
                    }
                }
                return '';
            },
        },
        {
            title: intl.formatMessage({
                id: 'admin.payments.credits.status.title',
            }),
            key: 'status',
            align: 'center',
            render: (companyPaymentCredit) => {
                const { invoices, purchasedCreditAmount, usedCreditAmount } = companyPaymentCredit;
                const areCreditsExpired = new Date() > new Date(companyPaymentCredit.expirationDate);
                const isPaymentPending = Boolean(invoices.length === 1 && invoices[0].isProforma);
                const isEveryCreditUsed = purchasedCreditAmount === usedCreditAmount;
                const areFreeCredits = companyPaymentCredit.invoices.length === 0;
                if (isPaymentPending) {
                    return ((0, jsx_runtime_1.jsx)(elements_1.Link, { href: "#invoices", children: (0, jsx_runtime_1.jsx)(CustomTag, { color: "blue", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.credits.status.waiting_for_payment" }) }) }));
                }
                if (areCreditsExpired && !isEveryCreditUsed) {
                    return ((0, jsx_runtime_1.jsx)(CustomTag, { color: "red", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.credits.status.expired" }) }));
                }
                if (areFreeCredits) {
                    return ((0, jsx_runtime_1.jsx)(CustomTag, { color: "green", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.credits.status.free" }) }));
                }
                return ((0, jsx_runtime_1.jsx)(CustomTag, { color: "success", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.credits.status.paid" }) }));
            },
        },
    ];
    return ((0, jsx_runtime_1.jsx)(elements_1.Table, { pagination: false, columns: columns, dataSource: companyPaymentsCreditsSortedByCreatedAt, scroll: paymentsTableScroll, rowKey: "id" }));
}
const CustomTag = (0, styled_components_1.default)(elements_1.Tag) `
	width: fit-content;
	margin: auto;
`;
